import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AccessDeniedPage = () => {
  const { user } = useAuth();
  
  // Determine where to redirect the user based on their role
  const homePath = user ? 
    (user.role === 'admin' || user.role === 'superadmin' ? '/admin/dashboard' : '/member/dashboard') 
    : '/';
    
  // Log information about the current state for debugging
  console.log('AccessDeniedPage - Current user:', user);
  console.log('AccessDeniedPage - Redirect path:', homePath);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center text-center px-4 py-16">
      <div className="rounded-full bg-red-100 p-4 mb-4">
        <svg 
          className="w-16 h-16 text-red-600" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            d="M12 15v2m0 0v2m0-2h2m-2 0H9m9 2H3a2 2 0 01-2-2V6a2 2 0 012-2h18a2 2 0 012 2v9a2 2 0 01-2 2z"
          />
        </svg>
      </div>
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Access Denied</h1>
      <p className="text-lg text-gray-600 max-w-md mb-8">
        Sorry, but you don't have permission to access this page. Please contact your administrator if you believe this is an error.
        {user && (
          <span className="block mt-2 text-sm text-gray-500">
            You are signed in as {user.email} with role: {user.role || 'unknown'}
          </span>
        )}
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
        <Link
          to={homePath}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-md inline-flex items-center justify-center"
        >
          Go to Dashboard
        </Link>
        <button
          onClick={() => window.history.back()}
          className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium px-6 py-3 rounded-md inline-flex items-center justify-center"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
